import { render, staticRenderFns } from "./wowKitOrdering.vue?vue&type=template&id=9efdd76e"
import script from "./wowKitOrdering.vue?vue&type=script&lang=js"
export * from "./wowKitOrdering.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports